// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20k8o","inner":"styles_inner__3rOyt","right":"styles_right__mZdRZ","close":"styles_close__3k2kP","footer":"styles_footer__2a1dW"};